<template>
  <div class="content">
    <div class="container">
      <el-form
        class="form_pad"
        ref="formPad"
        :inline="true"
        :model="listQuery"
      >
      <el-form-item :label="$t('statInfo.timeRange')">
        <el-date-picker
          v-model="dateRange"
          type="daterange"
          style="width: 302px"
          :range-separator="$t('statInfo.to')"
          :start-placeholder="$t('statInfo.startDate')"
          :end-placeholder="$t('statInfo.endDate')"
          value-format="yyyy-MM-dd"
          @change="querySearch"
          >
        </el-date-picker>
      </el-form-item>
      <!-- 操作系统 -->
      <el-form-item :label="$t('common.OS')">
        <el-select
          v-model="listQuery.os_type"
          clearable
          filterable
          style="width: 160px"
          :placeholder="$t('common.select')"
          @change="querySearch"
        >
          <el-option
            v-for="item in osList"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          />
        </el-select>
      </el-form-item>
      <!-- 应用 -->
      <el-form-item :label="$t('common.app')">
        <el-select
          v-model="listQuery.application_id"
          clearable
          filterable
          style="width: 160px"
          :placeholder="$t('common.select')"
          @change="appSelectChange"
        >
          <el-option
            v-for="item in appList"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          />
        </el-select>
      </el-form-item>
      <!-- 广告位 -->
      <el-form-item :label="$t('common.adZone')">
        <el-select
          v-model="listQuery.media_ad_slot"
          clearable
          filterable
          style="width: 160px"
          :placeholder="$t('common.select')"
          @change="querySearch"
        >
          <el-option
            v-for="item in adList"
            :key="item.id"
            :label="item.name+'【'+ item.ad_zone_id +'】'"
            :value="item.ad_zone_id"
          />
        </el-select>
      </el-form-item>
      <!-- 广告类型 -->
      <el-form-item :label="$t('sdk.flowType')">
        <el-select
            v-model="listQuery.flow_type"
            clearable
            filterable
            :placeholder="$t('common.selectFlowType')"
            style="width: 140px;"
            @change="querySearch"
            >
            <el-option
                v-for="item in [...$com.abroadList.flowTypeOpenAd, ...$com.abroadList.flowTypeList]"
                :key="item.id"
                :label="$i18n.locale == 'zh'?item.name : item.en_name"
                :value="item.id"
            />
        </el-select>
      </el-form-item>
      <!-- 合作模型 -->
      <el-form-item :label="$t('common.co_mode')">
        <el-select
          v-model="listQuery.co_mode"
          clearable
          filterable
          style="width: 140px"
          :placeholder="$t('common.select')"
          @change="querySearch"
        >
          <el-option
            v-for="(item, index) in coModeList"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          />
        </el-select>
      </el-form-item>
      <!-- 国家 -->
      <el-form-item :label="$t('common.country')">
        <el-select
          v-model="listQuery.country"
          clearable
          filterable
          multiple
          style="width: 160px"
          :placeholder="$t('common.select')"
          @change="querySearch"
        >
          <el-option
            v-for="item in countryList"
            :key="item.id"
            :label="item.name + item.code"
            :value="item.code"
          />
        </el-select>
      </el-form-item>
      <!-- <el-form-item :label="$t('common.subDim')">
        <el-select
          v-model="listQuery.segment_dim"
          clearable
          filterable
          style="width: 160px"
          :placeholder="$t('common.select')"
          @change="querySearchDim"
        >
          <el-option
            v-for="item in segmentList"
            :key="item.value"
            :label="$i18n.locale == 'zh'?item.name : item.en_name"
            :value="item.value"
          />
        </el-select>
      </el-form-item> -->  
      </el-form>
      <div class="form_pad">
        <p class="drawer_line clear_fix">
          {{$t('statInfo.trendChart')}}
          <el-button type="text" style="float: right" size="large" @click="chartFlag = !chartFlag">
            {{chartFlag? $t('statInfo.close') : $t('statInfo.open')}}
            <i :class="chartFlag? 'el-icon-arrow-up' : 'el-icon-arrow-down'"></i>
          </el-button>
        </p>
        <div v-show="chartFlag" style="width:100%;">
          <el-button-group class="btn_group" style="width:100%">
            <el-button type="text" 
              v-for="(item,index) in statsList" 
              :key="index"
              :class="activeStat == item.label?'active_class' : ''"
              plain
              size="large" 
              @click="handleCurrent(item.label, item.name)">
              {{item.name}}
            </el-button>
          </el-button-group>
        </div>
        <div v-show="chartFlag" style="width:100%;height:400px;text-align:center;line-height:400px" ref="chart" v-loading="listLoading">
          <div style="color: #909399">
            {{$t('statInfo.noData')}}
          </div>
        </div>
      </div>
      <div class="downLoad drawer_line clear_fix">
        <!-- <download-excel
            style="float:right"
            class = "export-excel-wrapper"
            :data = "json_data"
            :fields = "json_fields"
            :header="$t('statInfo.table')"
            :name ="$t('statInfo.table')+'.xls'"
            :fetch = "beforeFinish">
        </download-excel> -->
        {{$t('statInfo.summaryReport')}}
        <div class="btn_style" style="float:right">
          <span class="fred">
            {{$t('statInfo.downloadTip')}}
          </span>
          <el-button type="primary" size="mini" @click="exportExcel">
            <icon name="export" class="svg-icon exportIcon"/>
            {{$t('statInfo.export')}}
          </el-button>
        </div>
      </div>
      <div class="customColumn">
        {{$t('common.customColumn')}}：
        <label class="cc"><input type="checkbox" name="OS" v-model="customColumnList.is_os"/>{{$t('common.OS')}}</label>
        <label class="cc"><input type="checkbox" name="application" v-model="customColumnList.is_app" />{{$t('common.app')}}</label>
        <label class="cc"><input type="checkbox" name="addZone" v-model="customColumnList.is_ads" />{{$t('common.adZone')}}</label>
        <label class="cc"><input type="checkbox" name="flowType" v-model="customColumnList.is_flow_type"/>{{$t('sdk.flowType')}}</label>
        <label class="cc"><input type="checkbox" name="co_mode" v-model="customColumnList.is_mode" />{{$t('common.co_mode')}}</label>
        <label class="cc"><input type="checkbox" name="country" v-model="customColumnList.is_country" />{{$t('common.country')}}</label>
      </div>
      <div class="table-container">
        <el-table
          ref="orderTable"
          class="table"
          :data="tableList"
          style="width: 100%;margin-top:12px;"
          v-loading="listLoading"
          :header-cell-style="{whiteSpace: 'nowrap'}"
          >
          <el-table-column :label="$t('statInfo.date')" align="center" width="100" fixed="left">
            <template slot-scope="scope">
                {{ dateRange[0] === dateRange[1] ? formatSummary(scope.row.hr, $i18n.locale) : formatSummary(scope.row.dt, $i18n.locale) }}
            </template>
          </el-table-column>

          <el-table-column :label="$t('common.OS')" v-if="customColumnList.is_os" align="center" width="120">
            <template slot-scope="scope">{{scope.row.os_type}}</template>
          </el-table-column>
          <el-table-column :label="$t('common.app')" v-if="customColumnList.is_app" align="center" width="150">
            <template slot-scope="scope">{{scope.row.application}}</template>
          </el-table-column>
          <el-table-column :label="$t('common.adZone')" v-if="customColumnList.is_ads" align="center" width="280">
            <template slot-scope="scope">{{scope.row.media_ad_slot}}</template>
          </el-table-column>
          <el-table-column :label="$t('sdk.flowType')" v-if="customColumnList.is_flow_type" align="center" width="150">
            <template slot-scope="scope">
                <div style="word-break: keep-all">
                    {{scope.row.flow_type | filterCloumnValue([...$com.abroadList.flowTypeOpenAd, ...$com.abroadList.flowTypeList], $i18n.locale)}}
                </div>
            </template>
          </el-table-column>
          <el-table-column :label="$t('common.co_mode')" v-if="customColumnList.is_mode" align="center" width="120">
            <template slot-scope="scope">{{scope.row.co_mode}}</template>
          </el-table-column>
          <el-table-column :label="$t('common.country')" v-if="customColumnList.is_country" align="center" width="120">
            <template slot-scope="scope">{{scope.row.country}}</template>
          </el-table-column>

          <!-- <el-table-column :label="tabletitle1" align="left" v-if="listQuery.segment_dim">
            <template slot-scope="scope">{{ scope.row.name}}</template>
          </el-table-column>
          <el-table-column :label="tabletitle2" align="left" v-if="listQuery.segment_dim == 'media_ad_slot'">
            <template slot-scope="scope">{{ scope.row.col}}</template>
          </el-table-column> -->
          <el-table-column :label="$t('statInfo.rawReq')" align="center" width="120">
            <template slot-scope="scope">{{ scope.row.rawreq | commafyFilter}}</template>
          </el-table-column>
          <el-table-column :label="$t('statInfo.bid')" align="center" width="80">
            <template slot-scope="scope">{{ scope.row.bid | commafyFilter}}</template>
          </el-table-column>
          <el-table-column :label="$t('statInfo.exposure')" align="center" width="125">
            <template slot-scope="scope">{{ scope.row.imp | commafyFilter}}</template>
          </el-table-column>
          <el-table-column :label="$t('statInfo.exposureRate')" align="center" width="140">
            <template slot-scope="scope">{{ scope.row.imp_rate }}</template>
          </el-table-column>
          <el-table-column :label="$t('statInfo.click')" align="center width=108">
            <template slot-scope="scope">{{ scope.row.clk | commafyFilter}}</template>
          </el-table-column>
          <el-table-column :label="$t('statInfo.clickRate')" align="center" width="108">
            <template slot-scope="scope">{{ scope.row.click_rate }}</template>
          </el-table-column>
          <el-table-column :label="$t('statInfo.CPM')" align="center" width="108">
            <template slot-scope="scope">{{ scope.row.cpm_price }}</template>
          </el-table-column>
          <el-table-column :label="$t('statInfo.profit')" align="center" width="108">
            <template slot-scope="scope">{{ scope.row.ecpm_price}}</template>
          </el-table-column>
        </el-table>
        <el-pagination
          background
          class="pagination"
          @current-change="handleCurrentChange"
          @size-change="handleSizeChange"
          layout="total, sizes, prev, pager, next"
          :page-size="20"
          :current-page.sync="listQuery.page"
          :total="total"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import util from '@/utils/util';
import echarts from 'echarts'
import LAY_EXCEL from 'lay-excel'
export default {
  data() {
    return {
      activeStat: 'req',
      activeStatName: '',
      listLoading: false,
      chartFlag: true,
      dateRange: [],
      total: 0,
      exchange_id: null,
      customColumnList: {
        is_os: false,
        is_app: true,
        is_ads: true,
        is_flow_type: true,
        is_mode: false,
        is_country: false
      },
      listQuery: {
        template_id: 0,
        start_date: '',
        end_date: '',
        current_label: '',
        os_type: '',
        country: '',
        application_id: '',
        flow_type: '',
        media_ad_slot: '',
        media_ad_type: '',
        co_mode: '',
        segment_dim: '',
        is_all: 0,
        page: 1,
        page_size: 20,
      },
      tableList: [],
      appList: [],
      adList: [],
      osList: [],
      flowTypeList: [],
      countryList: [],
      coModeList: [],
      sourceList: [],
      segmentList: [
        {
          value: "media_ad_slot",
          name: "分广告位",
          en_name: "sub ad space"
        },
        // {
        //   value: "application_id",
        //   name: "分应用",
        //   en_name: "sub application"
        // },
        {
          value: "country",
          name: "分国家",
          en_name: "sub country"
        },
      ],
      chartData: {},
      // json_fields: {
      //   日期时间: "summary",      
      //   下发: "req",
      //   曝光: "imp",
      //   曝光率: "imp_rate",
      //   点击: "clk",
      //   点击率: "click_rate",
      //   CPM: "cpm_price",
      //   预估收益: "media_price",
      // },
      json_data: [],
      json_meta: [
        [
          {
            " key ": " charset ",
            " value ": " utf- 8 "
          }
        ]
      ],
      tabletitle1: "",
      tabletitle2: "",
    }
  },
  computed:{
    json_fields() {
      return {
        [this.$t('statInfo.date')]: "summary",     
        [this.tabletitle1]: "name",     
        [this.tabletitle2]: "col",  
        [this.$t('statInfo.rawReq')]: "raw_req",
        [this.$t('statInfo.bid')]: "bid",
        [this.$t('statInfo.exposure')]: "imp",
        [this.$t('statInfo.exposureRate')]: "imp_rate",
        [this.$t('statInfo.click')]: "clk",
        [this.$t('statInfo.clickRate')]: "click_rate",
        [this.$t('statInfo.CPM')]: "cpm_price",
        [this.$t('statInfo.profit')]: "media_price",
      }
    },
    statsList() {
      return [
        {
          label: "raw_req",
          name: this.$t('statInfo.rawReq')
        },
        {
          label: "bid",
          name: this.$t('statInfo.bid')
        },
        {
          label: "imp",
          name: this.$t('statInfo.exposure')
        },
        {
          label: "imp_rate",
          name: this.$t('statInfo.exposureRate')
        },
        {
          label: "clk",
          name: this.$t('statInfo.click')
        },
        {
          label: "click_rate",
          name: this.$t('statInfo.clickRate')
        },
        {
          label: "cpm_price",
          name: this.$t('statInfo.CPM')
        },
        {
          label: "media_price",
          name: this.$t('statInfo.profit')
        },
      ]
    }
  },
  filters: {
    filterCloumnValue(string,list,flag) {
      return util.filterCloumnValue(string,list,flag)
    },
    commafyFilter(val) {
      return util.commafy(val)
    },
    summaryFliter(val, locale) {
      let str = ""
      if(val == "汇总") {
        if(locale == "zh") {
          str = "汇总"
        } else {
          str = "summary"
        }
      } else {
        str = val
      }
      return str
    },
  },
  watch: {
    '$i18n.locale'(newVal) {
      this.setTableTitles(this.listQuery.segment_dim, newVal);
    },
    customColumnList:{
        handler: function() {
          this.getcustomColumnList()
        },
        deep:true
    }
  },
  created() {
    if(this.$i18n.locale == 'zh') {
      this.tabletitle1 = ''
      this.tabletitle2 = "应用"
    } else {
      this.tabletitle1 = ''
      this.tabletitle2 = "application"
    }
    // 初始化默认当天，模板全部
    this.dateRange[0] = util.getNowFormatDate()
    this.dateRange[1] = util.getNowFormatDate()
    this.listQuery.start_date = this.dateSplit(this.dateRange[0])
    this.listQuery.end_date = this.dateSplit(this.dateRange[1])
    this.getExchangeId()
    this.getAdlist()
    this.getApplist()
    this.getRestList()
  },
  mounted() {
    this.$eventBus.$on("getLang",function(val){})
  },
  methods: {
    formatSummary(val, locale) {
      let str = ""
      if(val == "汇总") {
        if(locale == "zh") {
          str = "汇总"
        } else {
          str = "summary"
        }
      } else {
        str = val
      }
      return str
    },
    // 获取应用下拉列表
    getApplist() {
      let params = {
        page: 1,
        page_size: 1000
      };
      this.__postData('sspAppList', params, (res) => {
        if(res.code == 1) {
          this.$message.error(res.msg);
        } else {
          this.appList = res.list
        }
      })
    },
    // 获取广告位下拉列表
    getAdlist() {
      this.__getData('getAdListAll', null, (res) => {
        this.adList = res
      })
    },
    // 获取剩下的参数
    getRestList() {
      this.__getData('getRestList', null, res => {      
        this.osList = res.data.os_types
        this.coModeList = res.data.co_modes
        this.countryList = res.data.countries
        this.flowTypeList =res.data.ad_types
      })
    },
    getExchangeId() {
       this.__getData("getExchangeId", null, res => {
        this.exchange_id = res.id
        if(res.id !== 0) {
          this.handleCurrent('bid', this.$t('statInfo.bid'))
          }
      })
    },
    // 获取自定义列表的数据
    getcustomColumnList(){
      if(this.exchange_id == 0) {
        return
      }
      this.listLoading = true
      this.listQuery.current_label = this.activeStat
      let params = {
        ...this.customColumnList,
        ...this.listQuery,
      }
      // 处理国家多选参数：将数组转换为后端需要的格式
      if (params.country && Array.isArray(params.country) && params.country.length > 0) {
        // 直接使用已有的国家代码构建查询字符串
        const countryQuery = params.country.map(code => 
          `${code}`
        ).join(',');
        params.country = countryQuery;
      }

      this.__getData('getcustomColumnList',params,res => {
        // console.log(res);
        
        this.listLoading = false
        if(res.code == 1) { 
          this.$message.error(res.msg);
        } else {
          this.chartData = res.data.chart
          this.tableList = res.data.table.data
          this.total = res.data.table.pageinfo.total_size
          
          this.$nextTick(() => {
            this.$refs.orderTable.doLayout();
          });
          // // 绘制图表
          this.handelInitCharts()
        }
      })
    },
    // getDimList() {
    //   this.__getData("dimList", null, res => {
    //     this.sourceList = res.template_info
    //   })
    // },
    /* getSumStatisticInfo() {
      if(this.exchange_id == 0) {
        return
      }
      this.listLoading = true
      this.listQuery.current_label = this.activeStat
      let params = util.filterParams(this.listQuery)
      this.__getData("getSumStatisticInfo", params, (res) => {
        this.listLoading = false
        if(res.code == 1) { 
          this.$message.error(res.msg);
        } else {
          this.chartData = res.data.chart
          this.tableList = res.data.table.data
          this.total = res.data.table.pageinfo.total_size
          // // 绘制图表
          this.handelInitCharts()
        }
      })
    }, */
    handleCurrent(val, name) {
      this.activeStat = val
      this.activeStatName = name
      // this.getSumStatisticInfo()
      this.getcustomColumnList()
    },
    querySearch() {
      if(this.dateRange.length > 0) {
        this.listQuery.start_date = this.dateSplit(this.dateRange[0])
        this.listQuery.end_date = this.dateSplit(this.dateRange[1])
      }
      // this.getSumStatisticInfo()
      this.getcustomColumnList()
    },
    appSelectChange() {
      this.listQuery.media_ad_slot = ""
      this.getAdlist()
      this.querySearch()
    },
    setTableTitles(segment_dim, locale) {
      if(locale === 'zh') {
        switch(segment_dim) {
          case 'template_id': this.tabletitle1 = '模板'; break;
          case 'application_id': this.tabletitle1 = '应用'; break;
          case 'media_ad_slot': 
            this.tabletitle1 = '广告位';
            this.tabletitle2 = '应用';
            break;
          case 'country': this.tabletitle1 = '国家'; break;
          default: this.tabletitle1 = '';
        }
      } else {
        switch(segment_dim) {
          case 'template_id': this.tabletitle1 = 'template'; break;
          case 'application_id': this.tabletitle1 = 'application'; break;
          case 'media_ad_slot':
            this.tabletitle1 = 'adZone';
            this.tabletitle2 = 'application';
            break;
          case 'country': this.tabletitle1 = 'country'; break;
          default: this.tabletitle1 = '';
        }
      }
    },
    querySearchDim(val) {
      this.setTableTitles(val, this.$i18n.locale);
      this.querySearch()
    },
    handleCurrentChange(val) {
      this.listQuery.page = val
      // this.getSumStatisticInfo()
      this.getcustomColumnList()
    },
    handleSizeChange(val) {
      this.listQuery.page = 1
      this.listQuery.page_size = val
      // this.getSumStatisticInfo()
      this.getcustomColumnList()
    },
    // 日期处理
    dateSplit(val){
      let str = ""
      if(val.substring(8,10).length == 1) {
        str = '0' + val.substring(8,10)
      } else {
        str = val.substring(8,10)
      }
      return val.substring(0,4) + val.substring(5,7) + str
    },
    // 除去数字多余的零
    cutZero(old){
        //拷贝一份 返回去掉零的新串
        let newstr=old;
        //循环变量 小数部分长度
        var leng = old.length-old.indexOf(".")-1
        //判断是否有效数
        if(old.indexOf(".")>-1){
          //循环小数部分
          for(var i=leng;i>0;i--){
                //如果newstr末尾有0
                if(newstr.lastIndexOf("0")>-1 && newstr.substr(newstr.length-1,1)==0){
                    var k = newstr.lastIndexOf("0");
                    //如果小数点后只有一个0 去掉小数点
                    if(newstr.charAt(k-1)=="."){
                        return  newstr.substring(0,k-1);
                    }else{
                    //否则 去掉一个0
                        newstr=newstr.substring(0,k);
                    }
                }else{
                //如果末尾没有0
                    return newstr;
                }
            }
        }
        return old;
    },
    handelInitCharts() {
      let that = this
      let myChart = echarts.init(this.$refs.chart);
      let yname = ""
      let subStr = this.activeStat.substring(this.activeStat.length-5, this.activeStat.length)
      if(subStr == '_rate') {
        yname = "%"
      } else if (subStr == 'price') {
         yname = "美元"
      }
        // 绘制图表
      myChart.setOption({
        tooltip: {
          trigger: 'axis',
          formatter(params){
            var res='<p>'+that.$t('statInfo.time') + '：'+params[0].name+'</p>' 
            for(var i=0;i<params.length;i++){
              res+='<p>'+params[i].marker + params[i].seriesName+'：'+ that.cutZero(params[i].data) +yname+'</p>'
            }
            return res
          }
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: this.chartData.time,
        },
        yAxis: {
          type: 'value',
          name: yname
        },
        legend: {
          data: [this.activeStatName],
          // data: [this.activeStatName, this.activeStatName+'同比'],
          right: 50,
          top: 20,
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true,
        },
        series: [
          {
            name: this.activeStatName,
            type: 'line',
            smooth: true,
            data: this.chartData.value,
          },
          {
            name: this.activeStatName + '同比',
            type: 'line',
            smooth: true,
          },
        ]
      });
      window.onresize = function () {
        myChart.resize();
      }
    },
    // 导出列表
    exportExcel() {
      this.listQuery.current_label = this.activeStat
      this.listQuery.is_all = 1
      let params = {
        ...this.customColumnList,
        ...this.listQuery,

      }
      // 处理国家多选参数：将数组转换为后端需要的格式
      if (params.country && Array.isArray(params.country) && params.country.length > 0) {
        // 直接使用已有的国家代码构建查询字符串
        const countryQuery = params.country.map(code => 
          `${code}`
        ).join(',');
        params.country = countryQuery;
      }
      this.__getData("getcustomColumnList", params, (res) => {
        let tableList = res.data.table.data
        this.listQuery.is_all = 0
        this.exportData(tableList)
      })
    },
    exportData(list) {
    // 根据时间范围选择日期字段
    const dateField = this.dateRange[0] === this.dateRange[1] ? 'hr' : 'dt';
    let arr = [dateField, 'name', 'rawreq', 'bid', 'imp', 'imp_rate', 'clk', 'click_rate', 'cpm_price', 'ecpm_price']
    let data = [[this.$t('statInfo.date'), this.tabletitle1, this.$t('statInfo.rawReq'), this.$t('statInfo.bid'), this.$t('statInfo.exposure'), this.$t('statInfo.exposureRate'), this.$t('statInfo.click'), this.$t('statInfo.clickRate'), this.$t('statInfo.CPM'), this.$t('statInfo.profit')]]

    const dynamicDimensions = {
      os_type: { 
        field: 'os_type',  
        name: this.$t('statInfo.os_type'),  
        checked: this.customColumnList.is_os 
      },
      application: {
        field: 'application',
        name: this.$t('statInfo.application'),
        checked: this.customColumnList.is_app
      },
      media_ad_slot: {
        field: 'media_ad_slot',
        name: this.$t('statInfo.media_ad_slot'),
        checked: this.customColumnList.is_ads
      },
      flow_type: { 
        field: 'flow_type', 
        name: this.$t('statInfo.template_id'), 
        checked: this.customColumnList.is_flow_type,
        format: (val) => { 
          return util.filterCloumnValue(
            val, 
            [...this.$com.abroadList.flowTypeOpenAd, ...this.$com.abroadList.flowTypeList], 
            this.$i18n.locale
          );
        }
      },
      co_mode: { 
          field: 'co_mode', 
          name: this.$t('statInfo.co_mode'), 
          checked: this.customColumnList.is_mode
      },
      country: { 
          field: 'country', 
          name: this.$t('statInfo.country'), 
          checked: this.customColumnList.is_country
      }       
    };
    // 分广告位的时候导出数据加上应用列
    if(this.listQuery.segment_dim == 'media_ad_slot') {
      arr.splice(2, 0, "col")
      data[0].splice(2, 0, this.tabletitle2)
    }
    // 如果this.tabletitle1为空，则导出时去掉第二列
    if(this.tabletitle1 == "") {
      arr.splice(1, 1)
      data[0].splice(1, 1)
    }
    const checkedDynamics = Object.values(dynamicDimensions).filter(item => item.checked);
    for (let i = checkedDynamics.length - 1; i >= 0; i--) {
      const item = checkedDynamics[i];
      arr.splice(1, 0, item.field); 
      data[0].splice(1, 0, item.name); 
    }
    list.map(el => {
      let newArr = []
      arr.forEach(item => {
        const dynamicItem = Object.values(dynamicDimensions).find(d => d.field === item);
        if (dynamicItem && dynamicItem.format) {
          newArr.push(dynamicItem.format(el[item]));
        } else if (item === 'hr' && this.dateRange[0] === this.dateRange[1]) {
          // 单日选择时，对hr字段进行格式化（处理"汇总"）
          newArr.push(this.formatSummary(el[item], this.$i18n.locale));
        } else {
          newArr.push(el[item]);
        }
      })
      data.push(newArr)
    })
    LAY_EXCEL.setExportCellStyle(data, 'A1:O1', {
      s: {
        fill: { bgColor: { indexed: 64 }, fgColor: { rgb: "d4e4f5" } },
        alignment: {
          horizontal: 'center',
          vertical: 'center'
        }
      }
    });
    LAY_EXCEL.exportExcel(data, '数据汇总列表.xlsx', 'xlsx',{
      extend: {
        '!cols': LAY_EXCEL.makeColConfig({
          'A': 100,
          'B': 230,
          'C': 230,
          'D': 160,
          'E': 120,
          'F': 100,
          'G': 100,
          'H': 100,
          'I': 100,
          'J': 100,
          'K': 100,
          'L': 100,
          'M': 100,
          'N': 100,
          'O': 100,
        }),
      }
    })
  }
    // beforeFinish() {
    //   this.listQuery.current_label = this.activeStat
    //   this.listQuery.is_all = 1
    //   let params = util.filterParams( this.listQuery)
    //   let list = []
    //   this.__getData("getSumStatisticInfo", params, (res) => {
    //     let downList = res.table.data
    //     for(var i = 0; i <= downList.length; i++) {
    //       let obj = new Object()
    //       for(var v in downList[i]) {
    //         for(var k in this.json_fields) {
    //           if(this.json_fields[k] == v) {
    //             obj[""+v+""] = downList[i][""+v+""]
    //           }
    //         }
    //       }
    //       list.push(obj)
    //     }
    //   })
    //   return list
    // },
  }
}
</script>
<style  lang="scss" scoped>
.exportIcon {
  width: 14px;
  height: 14px;
}
.btn_group .el-button {
  border: none!important;
  margin: 0 15px;
  color: rgba(0,0,0,0.85)!important;
  border-radius: 0!important;
  box-sizing: border-box;
  border-bottom: 2px solid transparent!important;
}
.btn_group  .active_class{
  color: #3361FF!important;
  border-bottom: 2px solid #3361FF!important;
}
.btn_group {
  display: flex;
  justify-content: center;
}
.downLoad {
  padding-top: 10px; 
}

.customColumn {
  font-weight: 500;
  margin: 20px 30px;
}

.cc {
  margin-left: 20px;
}

/* 新增表格外层容器样式 */
.table-container {
  width: 100%;
  overflow-x: auto; /* 水平超出显示滚动条 */
}

/* 确保表格单元格内容不换行 */
.el-table th,
.el-table td {
  white-space: nowrap;
}
</style>